export function isAgricultural(list: string[]): boolean {
  const agriculturalClassifications = [
    "dk.realequity.estate.landbrugsejendom",
    "dk.realequity.taxonomy.kategori.landbrug",
  ];
  return list.some((x) => agriculturalClassifications.includes(x));
}

export function isCountryEstate(list: string[]): boolean {
  const countryEstateClassifications = [
    "dk.realequity.taxonomy.markeringerpaaejendom.landejendom",
  ];
  return list.some((x) => countryEstateClassifications.includes(x));
}

export function isCommercial(list: string[]) {
  const commercialClassifications = [
    "dk.realequity.taxonomy.kategori.erhverv",
    "dk.realequity.estate.butikdetail",
  ];
  return list.some((x) => commercialClassifications.includes(x));
}

export function isHomeSale(list: string[]) {
  const homeSaleClassifications = ["dk.realequity.taxonomy.opdrag.salg"];
  return list.some((x) => homeSaleClassifications.includes(x));
}

export function isInvestmentProperty(list: string[]) {
  const investmentPropertyClassifications = [
    "dk.realequity.taxonomy.markeringerpaaejendom.investeringsejendom",
  ];
  return list.some((x) => investmentPropertyClassifications.includes(x));
}

export function isOwnProperty(list: string[]) {
  const ownPropertyClassifications = [
    "dk.realequity.taxonomy.markeringerpaaejendom.brugerejendom",
  ];
  return list.some((x) => ownPropertyClassifications.includes(x));
}

export function isLand(list: string[]) {
  const landClassifications = [
    "dk.realequity.estate.erhvervsgrund",
    "dk.realequity.estate.fritidsgrund",
    "dk.realequity.estate.helaarsgrund",
    "dk.realequity.taxonomy.markeringerpaaejendom.grund",
  ];
  return list.some((x) => landClassifications.includes(x));
}

export function isVillaRaekkehusOrFritidshus(list: string[]) {
  const classifications = [
    "dk.realequity.estate.villa",
    "dk.realequity.estate.raekkehus",
    "dk.realequity.estate.fritidshus",
  ];

  return list.some((x) => classifications.includes(x));
}
